import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_MONITORINGDOCUMENT_CREATE,
    ACTION_MONITORINGDOCUMENT_LOAD,
    ACTION_MONITORINGDOCUMENT_LOAD_BY_ID,

    ACTION_MONITORINGDOCUMENT_SAVE,
    ACTION_MONITORINGDOCUMENT_VALIDATE,
    ACTION_MONITORINGDOCUMENTS_LOAD_BY_MONITORING_ID,
    CreateFailure,
    CreateSuccess,
    IMonitoringDocumentCreateAction,
    IMonitoringDocumentCreateFailureAction,
    IMonitoringDocumentCreateSuccessAction,
    IMonitoringDocumentLoadAction,
    IMonitoringDocumentLoadByIdAction,
    IMonitoringDocumentLoadFailureAction,
    IMonitoringDocumentLoadSuccessAction,

    IMonitoringDocumentSaveAction,
    IMonitoringDocumentSaveFailureAction,
    IMonitoringDocumentSaveSuccessAction,
    IMonitoringDocumentValidateAction,
    IMonitoringDocumentValidateFailureAction,
    IMonitoringDocumentValidateSuccessAction,
    IMonitoringDocumentsLoadByMonitoringIdAction,
    LoadFailure,
    LoadSuccess,
    SaveFailure,
    SaveSuccess,
    ValidateFailure,
    ValidateSuccess,
} from "../actions/monitoringDocument";
import { monitoringDocumentsApi } from "../services/monitoringDocuments";

export const
    getMonitoringDocumentsEpic = (action$): Observable<IMonitoringDocumentLoadSuccessAction | IMonitoringDocumentLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGDOCUMENT_LOAD)
            .mergeMap((_action: IMonitoringDocumentLoadAction) => {
                return monitoringDocumentsApi
                    .getMonitoringDocuments()
                    .map(response =>
                        LoadSuccess(response.monitoringDocuments, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitoringDocumentsByMonitoringIdEpic = (action$): Observable<IMonitoringDocumentLoadSuccessAction | IMonitoringDocumentLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGDOCUMENTS_LOAD_BY_MONITORING_ID)
            .mergeMap((action: IMonitoringDocumentsLoadByMonitoringIdAction) => {
                return monitoringDocumentsApi
                    .getMonitoringDocumentsByMonitoringId(action.monitoringId)
                    .map(response =>
                        LoadSuccess(response.monitoringDocuments, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitoringDocumentsByIdEpic = (action$): Observable<IMonitoringDocumentLoadSuccessAction | IMonitoringDocumentLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGDOCUMENT_LOAD_BY_ID)
            .mergeMap((action: IMonitoringDocumentLoadByIdAction) => {
                return monitoringDocumentsApi
                    .getMonitoringDocumentById(action.id)
                    .map(response =>
                        LoadSuccess(response.monitoringDocument, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setMonitoringDocumentEpic = (action$): Observable<IMonitoringDocumentSaveSuccessAction | IMonitoringDocumentSaveFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGDOCUMENT_SAVE)
            .mergeMap((action: IMonitoringDocumentSaveAction) => {
                return monitoringDocumentsApi
                    .setMonitoringDocument(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.monitoringDocument, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createMonitoringDocumentEpic = (action$): Observable<IMonitoringDocumentCreateSuccessAction | IMonitoringDocumentCreateFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGDOCUMENT_CREATE)
            .mergeMap((action: IMonitoringDocumentCreateAction) => {
                return monitoringDocumentsApi
                    .createMonitoringDocument(action.monitoringId)
                    .map(response =>
                        CreateSuccess(response.monitoringDocument, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateMonitoringDocumentEpic = (action$): Observable<IMonitoringDocumentValidateSuccessAction | IMonitoringDocumentValidateFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGDOCUMENT_VALIDATE)
            .mergeMap((action: IMonitoringDocumentValidateAction) => {
                return monitoringDocumentsApi
                    .validateMonitoringDocument(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.monitoringDocument, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }